module.exports = __webpack_public_path__ + "static/Chap-regular-ad4d1b566c28300ea3b1eae2186d756e.otf";